/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LlmConfigurationToggleLlmConfigPut$Params {
  fleetId?: string;
  active?: boolean;
}

export function llmConfigurationToggleLlmConfigPut(http: HttpClient, rootUrl: string, params?: LlmConfigurationToggleLlmConfigPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, llmConfigurationToggleLlmConfigPut.PATH, 'put');
  if (params) {
    rb.query('fleetId', params.fleetId, {});
    rb.query('active', params.active, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

llmConfigurationToggleLlmConfigPut.PATH = '/LLMConfiguration/ToggleLLMConfig';
